import { useReducer as e, useCallback as t } from "react";
var n = {
    past: [],
    present: null,
    future: []
  },
  r = function r(e, t) {
    var n = e.past,
      r = e.present,
      u = e.future;
    switch (t.type) {
      case "UNDO":
        var s = n[n.length - 1];
        return {
          past: n.slice(0, n.length - 1),
          present: s,
          future: [r].concat(u)
        };
      case "REDO":
        var a = u[0],
          c = u.slice(1);
        return {
          past: n.concat([r]),
          present: a,
          future: c
        };
      case "SET":
        var p = t.newPresent;
        return p === r ? e : {
          past: n.concat([r]),
          present: p,
          future: []
        };
      case "RESET":
        return {
          past: [],
          present: t.newPresent,
          future: []
        };
    }
  };
export default function (u) {
  var s = e(r, Object.assign({}, n, {
      present: u
    })),
    a = s[0],
    c = s[1],
    p = 0 !== a.past.length,
    o = 0 !== a.future.length,
    f = t(function () {
      p && c({
        type: "UNDO"
      });
    }, [p]),
    i = t(function () {
      o && c({
        type: "REDO"
      });
    }, [o]);
  return [a, {
    set: t(function (e) {
      return c({
        type: "SET",
        newPresent: e
      });
    }, []),
    reset: t(function (e) {
      return c({
        type: "RESET",
        newPresent: e
      });
    }, []),
    undo: f,
    redo: i,
    canUndo: p,
    canRedo: o
  }];
}